import { dia, util } from '@clientio/rappid';

import { FlowchartConfig } from '../base/flowchart.config';

const { Element, ElementView } = dia;

const PATH_CARET_DOWN = '/assets/icons/chevron-down.svg';
const PATH_CARET_UP = '/assets/icons/chevron-up.svg';

export class SelectionBehaviorElement extends Element {
  markup = [
    {
      tagName: 'rect',
      selector: 'body',
    },
    {
      tagName: 'svg',
      selector: 'container',
      children: [
        {
          tagName: 'text',
          selector: 'label',
        },
        {
          tagName: 'image',
          selector: 'image',
        },
      ],
    },
  ];

  private allowEvents = false;

  constructor(parameters: joint.dia.Element.Attributes, allowEvents = false) {
    super(parameters, { allowEvents });
  }

  initialize(attributes?: dia.Element.Attributes, options?: Record<string, unknown>): void {
    this.allowEvents = (options?.['allowEvents'] as boolean) ?? false;
    super.initialize(attributes, options);

    if (this.allowEvents) {
      this.attr('image/display', 'block');
    }
  }

  defaults(attributes?: dia.Element.Attributes, options?: Record<string, unknown>): Partial<dia.Element.Attributes> {
    const { height, width } = FlowchartConfig.selectionBehaviorNode.size;

    return util.defaultsDeep(
      {
        type: 'treetop.SelectionBehavior',
        size: { height, width },
        attrs: {
          body: {
            width: 'calc(w)',
            height: 'calc(h)',
            class: 'element--selectionbehavior__body',
            rx: 12,
            fill: '#ffffff',
            stroke: '#d0dce7',
            strokeWidth: 2,
          },
          container: {
            textAnchor: 'middle',
            y: 0,
            width: 'calc(w)',
            height: 'calc(h)',
          },
          image: {
            'xlink:href': PATH_CARET_DOWN,
            x: 'calc(w - 18)',
            height,
            width: 14,
            preserveAspectRatio: true,
            class: 'element--selectionbehavior__arrow',
            display: 'none',
          },
          label: {
            fontFamily: "'Roboto', 'Helvetica Neue', sans-serif",
            fontSize: 13,
            fontWeight: 500,
            fill: '#063d70',
            width: 'calc(w)',
            textAnchor: 'middle',
            'ref-x': 0.5,
            'ref-y': 0.5,
            text: 'and/or',
            textVerticalAnchor: 'middle',
            class: 'element--selectionbehavior__text',
            'data-testid': 'flowchart-element_selectionbehavior',
          },
        },
      },

      super.defaults,
    );
  }

  public closeCaret(): void {
    this.attr('image/xlink:href', PATH_CARET_DOWN);
  }

  public openCaret(): void {
    this.attr('image/xlink:href', PATH_CARET_UP);
  }

  public setText(text: string): void {
    this.attr('label/text', text);
  }
}

export class SelectionBehaviorElementView extends ElementView {
  model: SelectionBehaviorElement;

  public caretOpen(): boolean {
    return this.model.attr('image/xlink:href') === PATH_CARET_UP;
  }

  public onButtonClick(evt: JQuery.Event) {
    if (!this.model['allowEvents']) return;

    if (this.caretOpen()) {
      this.model.closeCaret();
      this.notify('selectionBehavior:close', evt);
    } else {
      this.model.openCaret();
      this.notify('selectionBehavior:open', evt);
    }
  }
}
